import {useMemo} from 'react';
import {ILabel} from 'modules/products/types';
import {LABELS_CODES} from 'components/ProductSnippet/ProductSnippet.constants';
import {TSnippetVersion} from 'core/types';

export const useProductLabels = (labels: ILabel[] = [], snippetVersion: TSnippetVersion = 'v2') => {
    return useMemo(() => {
        const filteredLabels =
            'v2' === snippetVersion ? labels.filter((label) => label.code !== LABELS_CODES.ONLINE_ONLY) : labels;

        return filteredLabels
            .map((label) => {
                let tooltip = label.shortDescription || null;

                if (label.code === LABELS_CODES.IN_STOCK || label.code === LABELS_CODES.GIFT_IN_CART) {
                    tooltip = `Участвует в акции «${label.saleTitle}»`;
                }

                return {
                    code: label.code,
                    title: label.title,
                    tooltip,
                    url: label.url || null,
                    saleTitle: label.saleTitle || null,
                };
            })
            .slice(0, 2);
    }, [labels, snippetVersion]);
};
